import React from "react";

const VSmallIcon = ({ children }) => {
  return React.cloneElement(children, { height: "12px", width: "12px" });
};

export default VSmallIcon;
